// extracted by mini-css-extract-plugin
module.exports = {"iconAndTextGrouping":"UiChip_iconAndTextGrouping__2b_dP","defaultIconStyle":"UiChip_defaultIconStyle__36LZb"};